import React from 'react';
import { ResultTab } from './SearchTab';
import type { SearchState } from './SearchTab';
import SearchBrandAccounts from './SearchBrandAccounts';
import SearchKeywords from './SearchKeywords';
import SearchResults from './SearchResults';
import { UserType } from '../../../types/userType';
import { SearchResponse } from '../../../types/searchType';

interface SearchContentProps {
  searchState: SearchState;
  searchQuery: string;
  activeResultTab: ResultTab;
  setActiveResultTab: React.Dispatch<React.SetStateAction<ResultTab>>;
  searchResults: SearchResponse | null;
  isLoading: boolean;
  currentUser: UserType | null;
  onSearch: (query: string) => void;
}

const SearchContent: React.FC<SearchContentProps> = ({
  searchState,
  searchQuery,
  activeResultTab,
  setActiveResultTab,
  searchResults,
  isLoading,
  currentUser,
  onSearch
}) => {
  switch (searchState) {
    case 'initial':
      return <SearchBrandAccounts />;
    case 'focused':
      return <SearchKeywords onKeywordClick={onSearch} />;
    case 'typing':
    case 'results':
      return (
        <SearchResults
          searchQuery={searchQuery}
          activeTab={activeResultTab}
          setActiveTab={setActiveResultTab}
          searchResults={searchResults}
          isLoading={isLoading}
          currentUser={currentUser}
        />
      );
    default:
      return null;
  }
};

export default SearchContent;
